var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntegration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.121,
    height: 74.912,
    viewBox: "0 0 95.121 74.912",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_786",
    "data-name": "Group 786",
    transform: "translate(0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_736",
    "data-name": "Group 736",
    transform: "translate(27.634 19.142)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_402",
    "data-name": "Rectangle 402",
    width: 5.202,
    height: 20.994,
    transform: "translate(30.233 34.626)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_403",
    "data-name": "Rectangle 403",
    width: 65.668,
    height: 39.833,
    transform: "translate(1.319)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_404",
    "data-name": "Rectangle 404",
    width: 65.668,
    height: 39.833,
    fill: "#f3a51c",
    stroke: "#140578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_735",
    "data-name": "Group 735",
    transform: "translate(2.366 1.434)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_405",
    "data-name": "Rectangle 405",
    width: 60.937,
    height: 36.961,
    fill: "#fff",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_406",
    "data-name": "Rectangle 406",
    width: 60.937,
    height: 2.225,
    transform: "translate(0 34.736)",
    fill: "#fff",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M114.072,164.65,94.78,165.9v1.258H132.8V165.9Z",
    transform: "translate(-80.954 -111.387)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_407",
    "data-name": "Rectangle 407",
    width: 60.937,
    height: 36.961,
    transform: "translate(2.366 1.434)",
    fill: "#fff",
    stroke: "#140578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_738",
    "data-name": "Group 738",
    transform: "translate(46.042 0.264)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    x1: 5.224,
    y2: 7.924,
    transform: "translate(0 11.834)",
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_737",
    "data-name": "Group 737",
    transform: "translate(1.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M120.784,9.127v-1.8l-1.8-.2a4.408,4.408,0,0,0-.44-1.073l1.135-1.42-1.271-1.271L117,4.5a4.329,4.329,0,0,0-1.069-.449l-.2-1.807h-1.8l-.2,1.8a4.408,4.408,0,0,0-1.073.44l-1.42-1.135-1.271,1.271,1.13,1.412a4.329,4.329,0,0,0-.449,1.069l-1.807.2V9.1l1.8.2a4.408,4.408,0,0,0,.44,1.073l-1.135,1.42,1.271,1.271,1.412-1.13a4.329,4.329,0,0,0,1.069.449l.2,1.807h1.8l.2-1.8a4.408,4.408,0,0,0,1.073-.44l1.42,1.135,1.271-1.271-1.13-1.412a4.331,4.331,0,0,0,.449-1.069Zm-5.972,1.236a2.146,2.146,0,1,1,2.146-2.146A2.146,2.146,0,0,1,114.812,10.362Z",
    transform: "translate(-108.84 -1.519)",
    fill: "#9c2eff",
    stroke: "#140578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M141.749,4.6l-.2-1.192-1.214.066a2.811,2.811,0,0,0-.409-.66l.594-1.064-.985-.7-.809.906a2.748,2.748,0,0,0-.756-.176L137.637.6l-1.192.2.066,1.214a2.811,2.811,0,0,0-.66.409l-1.064-.594-.7.985.906.809a2.748,2.748,0,0,0-.176.756l-1.174.334.2,1.192,1.214-.066a2.811,2.811,0,0,0,.409.66l-.594,1.064.985.7.809-.906a2.748,2.748,0,0,0,.756.176l.334,1.174,1.192-.2L138.877,7.3a2.811,2.811,0,0,0,.66-.409l1.064.594.7-.985-.906-.809a2.749,2.749,0,0,0,.176-.756Zm-3.817,1.478a1.44,1.44,0,1,1,1.183-1.658A1.438,1.438,0,0,1,137.932,6.075Z",
    transform: "translate(-122.734 -0.6)",
    fill: "#140578"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_747",
    "data-name": "Group 747",
    transform: "translate(27.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_740",
    "data-name": "Group 740",
    transform: "translate(8.516 12.181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_739",
    "data-name": "Group 739"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    x2: 0.211,
    y2: 1.077,
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    x2: 0.58,
    y2: 2.916,
    transform: "translate(0.598 3.021)",
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4.508 4.508"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    x2: 0.215,
    y2: 1.082,
    transform: "translate(1.372 6.908)",
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_746",
    "data-name": "Group 746",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_741",
    "data-name": "Group 741",
    transform: "translate(0 2.39)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_408",
    "data-name": "Rectangle 408",
    width: 2.432,
    height: 9.05,
    transform: "translate(12.157 9.05) rotate(180)",
    fill: "#9c2eff",
    stroke: "#140578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_409",
    "data-name": "Rectangle 409",
    width: 2.432,
    height: 7.023,
    transform: "translate(8.916 9.053) rotate(180)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_410",
    "data-name": "Rectangle 410",
    width: 2.432,
    height: 5.405,
    transform: "translate(5.674 9.052) rotate(180)",
    fill: "#9c2eff",
    stroke: "#140578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_411",
    "data-name": "Rectangle 411",
    width: 2.432,
    height: 4.055,
    transform: "translate(2.432 9.053) rotate(180)",
    fill: "#140578"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_745",
    "data-name": "Group 745",
    transform: "translate(0.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_742",
    "data-name": "Group 742",
    transform: "translate(0 0.602)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M65.1,7.557l-.237-.312,2.489-1.891,1.231.413,2.036-2.194,1.2.365,2.172-2.489.919.6.954-.677.224.321-1.17.827-.858-.554L71.94,4.387l-1.2-.365-2.04,2.194-1.275-.422Z",
    transform: "translate(-64.86 -1.37)",
    fill: "#140578"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_744",
    "data-name": "Group 744",
    transform: "translate(10.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_743",
    "data-name": "Group 743"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M89.48,1.667,90.249,0,88.42.167Z",
    transform: "translate(-88.42)",
    fill: "#140578"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_754",
    "data-name": "Group 754",
    transform: "translate(2.094 4.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_749",
    "data-name": "Group 749",
    transform: "translate(14.767 7.383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_748",
    "data-name": "Group 748"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    x2: 0.915,
    y2: 0.607,
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x2: 8.738,
    y2: 5.774,
    transform: "translate(2.507 1.658)",
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4.331 4.331"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    x2: 0.919,
    y2: 0.607,
    transform: "translate(12.036 7.96)",
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_753",
    "data-name": "Group 753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_751",
    "data-name": "Group 751",
    transform: "translate(2.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M24.662,19.828H9.97V12.986a2.8,2.8,0,0,1,2.806-2.806h9.085a2.8,2.8,0,0,1,2.806,2.806v6.843Z",
    transform: "translate(-9.97 -10.18)",
    fill: "#fff",
    stroke: "#140578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_750",
    "data-name": "Group 750",
    transform: "translate(3.707 3.879)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    x2: 6.961,
    fill: "none",
    stroke: "#140578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    x2: 6.961,
    transform: "translate(0 1.121)",
    fill: "none",
    stroke: "#140578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    x2: 6.961,
    transform: "translate(0 2.243)",
    fill: "none",
    stroke: "#140578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    x2: 6.961,
    transform: "translate(0 3.364)",
    fill: "none",
    stroke: "#140578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M24.662,11.7v-.624a.9.9,0,0,0-.9-.9h-12.9a.9.9,0,0,0-.9.9V11.7Z",
    transform: "translate(-9.97 -10.18)",
    fill: "#9c2eff",
    stroke: "#140578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M37.087,11.709a.229.229,0,1,0-.229.229A.227.227,0,0,0,37.087,11.709Z",
    transform: "translate(-24.906 -10.908)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M39.147,11.709a.229.229,0,1,0-.229.229A.227.227,0,0,0,39.147,11.709Z",
    transform: "translate(-26.06 -10.908)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M41.207,11.709a.229.229,0,1,0-.229.229A.227.227,0,0,0,41.207,11.709Z",
    transform: "translate(-27.214 -10.908)",
    fill: "#140578"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_752",
    "data-name": "Group 752",
    transform: "translate(0 2.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M5.467,29.71h0A.57.57,0,0,1,5.4,28.9L9.53,24.16l.629.523L6.276,29.622A.57.57,0,0,1,5.467,29.71Z",
    transform: "translate(-5.261 -20.048)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M8.431,27.03,5.4,30.5a.569.569,0,1,0,.875.726l2.867-3.641Z",
    transform: "translate(-5.261 -21.656)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M17.365,15.407a2.6,2.6,0,1,0,.343,3.668A2.607,2.607,0,0,0,17.365,15.407Zm-3.083,3.72a2.227,2.227,0,1,1,3.135-.295A2.222,2.222,0,0,1,14.282,19.128Z",
    transform: "translate(-9.652 -14.809)",
    fill: "#140578"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_758",
    "data-name": "Group 758",
    transform: "translate(0 23.883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_756",
    "data-name": "Group 756",
    transform: "translate(11.719 8.426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_755",
    "data-name": "Group 755"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    x2: 1.099,
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    x2: 11.825,
    transform: "translate(3.25)",
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4.89 4.89"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    x2: 1.099,
    transform: "translate(16.152)",
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_757",
    "data-name": "Group 757"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    x2: 9.736,
    transform: "translate(4.635 2.018)",
    fill: "none",
    stroke: "#140578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    y1: 4.798,
    transform: "translate(9.503 2.018)",
    fill: "none",
    stroke: "#140578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    y2: 6.064,
    transform: "translate(1.79 3.215)",
    fill: "none",
    stroke: "#140578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M25.87,76.86h8.813v5.33",
    transform: "translate(-14.713 -66.944)",
    fill: "none",
    stroke: "#140578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    y2: 5.141,
    transform: "translate(14.371 10.009)",
    fill: "none",
    stroke: "#140578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_412",
    "data-name": "Rectangle 412",
    width: 6.337,
    height: 4.314,
    transform: "translate(0.044)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_413",
    "data-name": "Rectangle 413",
    width: 6.337,
    height: 4.314,
    transform: "translate(12.027)",
    fill: "#9c2eff",
    stroke: "#140578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_414",
    "data-name": "Rectangle 414",
    width: 4.059,
    height: 2.766,
    transform: "translate(12.397 13.865)",
    fill: "#9c2eff",
    stroke: "#140578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_415",
    "data-name": "Rectangle 415",
    width: 4.059,
    height: 2.766,
    transform: "translate(0 7.898)",
    fill: "#fff",
    stroke: "#140578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_416",
    "data-name": "Rectangle 416",
    width: 4.059,
    height: 2.766,
    transform: "translate(17.722 13.865)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_417",
    "data-name": "Rectangle 417",
    width: 4.516,
    height: 4.516,
    transform: "translate(6.31 10.006) rotate(-45)",
    fill: "#9c2eff",
    stroke: "#140578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_764",
    "data-name": "Group 764",
    transform: "translate(0.875 49.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_760",
    "data-name": "Group 760",
    transform: "translate(20.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_759",
    "data-name": "Group 759"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_34",
    "data-name": "Line 34",
    y1: 0.356,
    x2: 1.042,
    transform: "translate(0 2.432)",
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    y1: 1.038,
    x2: 3.047,
    transform: "translate(3.069 0.699)",
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4.878 4.878"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    y1: 0.352,
    x2: 1.042,
    transform: "translate(7.128)",
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_763",
    "data-name": "Group 763",
    transform: "translate(0 0.11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_418",
    "data-name": "Rectangle 418",
    width: 19.406,
    height: 4.556,
    fill: "#fff",
    stroke: "#140578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_761",
    "data-name": "Group 761",
    transform: "translate(9.2 5.651)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_419",
    "data-name": "Rectangle 419",
    width: 10.141,
    height: 6.033,
    fill: "#fff",
    stroke: "#140578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M23.41,135.227l3.531-2.823,1.478,1.091L31.5,131.12l1.992,1.926v2.181Z",
    transform: "translate(-23.41 -129.194)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 0.708,
    cy: 0.708,
    rx: 0.708,
    ry: 0.708,
    transform: "translate(1.025 0.831)",
    fill: "#140578",
    stroke: "#140578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_762",
    "data-name": "Group 762",
    transform: "translate(9.2 12.52)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_420",
    "data-name": "Rectangle 420",
    width: 10.141,
    height: 6.033,
    fill: "#fff",
    stroke: "#140578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M23.41,150.847l3.531-2.823,1.478,1.091L31.5,146.74l1.992,1.922v2.186Z",
    transform: "translate(-23.41 -144.814)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 0.708,
    cy: 0.708,
    rx: 0.708,
    ry: 0.708,
    transform: "translate(1.025 0.831)",
    fill: "#140578",
    stroke: "#140578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    x2: 7.713,
    transform: "translate(0.295 6.104)",
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_38",
    "data-name": "Line 38",
    x2: 7.713,
    transform: "translate(0.295 7.819)",
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    x2: 7.713,
    transform: "translate(0.295 9.529)",
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_40",
    "data-name": "Line 40",
    x2: 7.713,
    transform: "translate(0.295 11.244)",
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_41",
    "data-name": "Line 41",
    x2: 7.713,
    transform: "translate(0.295 12.955)",
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    x2: 7.713,
    transform: "translate(0.295 14.67)",
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    x2: 7.713,
    transform: "translate(0.295 16.381)",
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    x2: 7.713,
    transform: "translate(0.295 18.096)",
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_769",
    "data-name": "Group 769",
    transform: "translate(60.281 22.581)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_421",
    "data-name": "Rectangle 421",
    width: 29.384,
    height: 8.324,
    fill: "#fff",
    stroke: "#140578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_765",
    "data-name": "Group 765",
    transform: "translate(10.739 10.321)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_422",
    "data-name": "Rectangle 422",
    width: 18.527,
    height: 11.02,
    fill: "#fff",
    stroke: "#140578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M162,90.322l6.451-5.158,2.7,1.992,5.629-4.336,3.632,3.514v3.989Z",
    transform: "translate(-162 -79.302)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M168.847,79.578a1.288,1.288,0,1,1-1.288-1.288A1.287,1.287,0,0,1,168.847,79.578Z",
    transform: "translate(-164.392 -76.764)",
    fill: "#140578"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_766",
    "data-name": "Group 766",
    transform: "translate(10.739 22.867)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_423",
    "data-name": "Rectangle 423",
    width: 18.527,
    height: 11.02,
    fill: "#fff",
    stroke: "#140578",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M162,118.852l6.451-5.158,2.7,1.992,5.629-4.336,3.632,3.518v3.984Z",
    transform: "translate(-162 -107.832)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M168.847,108.108a1.288,1.288,0,1,1-1.288-1.288A1.287,1.287,0,0,1,168.847,108.108Z",
    transform: "translate(-164.392 -105.294)",
    fill: "#140578"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_768",
    "data-name": "Group 768",
    transform: "translate(0.8 23.786)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_767",
    "data-name": "Group 767"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M140.121,109.868l-.721-4.428h.515l.475,3.184.6-3.166h.435l.6,3.184.466-3.2h.5l-.712,4.428h-.449l-.616-3.281-.624,3.281h-.471Z",
    transform: "translate(-139.4 -105.44)",
    fill: "#140578"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    x2: 4.332,
    transform: "translate(4.266 0.268)",
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    x2: 4.332,
    transform: "translate(4.266 1.464)",
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_47",
    "data-name": "Line 47",
    x2: 4.332,
    transform: "translate(4.266 2.656)",
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    x2: 4.332,
    transform: "translate(4.266 3.852)",
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_49",
    "data-name": "Line 49",
    x2: 4.332,
    transform: "translate(4.266 5.048)",
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_50",
    "data-name": "Line 50",
    x2: 4.332,
    transform: "translate(4.266 6.24)",
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_51",
    "data-name": "Line 51",
    x2: 4.332,
    transform: "translate(4.266 7.436)",
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_52",
    "data-name": "Line 52",
    x2: 4.332,
    transform: "translate(4.266 8.632)",
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_53",
    "data-name": "Line 53",
    x2: 4.332,
    transform: "translate(4.266 9.828)",
    fill: "none",
    stroke: "#140578",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_785",
    "data-name": "Group 785",
    transform: "translate(30 20.576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M101.482,59.292A5.987,5.987,0,0,0,98.157,60.3V46.79H68.72V83.751H98.161V70.242a5.98,5.98,0,1,0,3.32-10.95Z",
    transform: "translate(-68.72 -46.79)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_784",
    "data-name": "Group 784",
    transform: "translate(3.061 2.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_782",
    "data-name": "Group 782",
    transform: "translate(0 3.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_775",
    "data-name": "Group 775"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_54",
    "data-name": "Line 54",
    x2: 13.25,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_55",
    "data-name": "Line 55",
    x2: 6.917,
    transform: "translate(0 3.962)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_770",
    "data-name": "Group 770",
    transform: "translate(0 1.785)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_56",
    "data-name": "Line 56",
    x2: 6.447,
    fill: "none",
    stroke: "#f3a51c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_57",
    "data-name": "Line 57",
    x2: 3.404,
    transform: "translate(7.854)",
    fill: "none",
    stroke: "#f3a51c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_58",
    "data-name": "Line 58",
    x2: 3.399,
    transform: "translate(13.25)",
    fill: "none",
    stroke: "#f3a51c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_771",
    "data-name": "Group 771",
    transform: "translate(0 5.651)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_59",
    "data-name": "Line 59",
    x2: 6.447,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_60",
    "data-name": "Line 60",
    x2: 3.404,
    transform: "translate(7.854)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_61",
    "data-name": "Line 61",
    x2: 3.399,
    transform: "translate(13.25)",
    fill: "none",
    stroke: "#f3a51c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_772",
    "data-name": "Group 772",
    transform: "translate(0 9.516)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_62",
    "data-name": "Line 62",
    x2: 6.447,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63",
    "data-name": "Line 63",
    x2: 3.404,
    transform: "translate(7.854)",
    fill: "none",
    stroke: "#f3a51c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_64",
    "data-name": "Line 64",
    x2: 3.399,
    transform: "translate(13.25)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_773",
    "data-name": "Group 773",
    transform: "translate(3.989 11.2)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_65",
    "data-name": "Line 65",
    x2: 4.903,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_66",
    "data-name": "Line 66",
    x2: 2.586,
    transform: "translate(5.972)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_67",
    "data-name": "Line 67",
    x2: 2.586,
    transform: "translate(10.075)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_774",
    "data-name": "Group 774",
    transform: "translate(3.989 13.28)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_68",
    "data-name": "Line 68",
    x2: 4.903,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_69",
    "data-name": "Line 69",
    x2: 2.586,
    transform: "translate(5.972)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_70",
    "data-name": "Line 70",
    x2: 2.586,
    transform: "translate(10.075)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_781",
    "data-name": "Group 781",
    transform: "translate(0 15.563)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_71",
    "data-name": "Line 71",
    x2: 13.25,
    fill: "none",
    stroke: "#f3a51c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_72",
    "data-name": "Line 72",
    x2: 6.917,
    transform: "translate(0 3.962)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_776",
    "data-name": "Group 776",
    transform: "translate(0 1.781)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_73",
    "data-name": "Line 73",
    x2: 6.447,
    fill: "none",
    stroke: "#f3a51c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_74",
    "data-name": "Line 74",
    x2: 3.404,
    transform: "translate(7.854)",
    fill: "none",
    stroke: "#f3a51c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_75",
    "data-name": "Line 75",
    x2: 3.399,
    transform: "translate(13.25)",
    fill: "none",
    stroke: "#f3a51c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_777",
    "data-name": "Group 777",
    transform: "translate(0 5.651)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_76",
    "data-name": "Line 76",
    x2: 6.447,
    fill: "none",
    stroke: "#f3a51c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_77",
    "data-name": "Line 77",
    x2: 3.404,
    transform: "translate(7.854)",
    fill: "none",
    stroke: "#f3a51c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_78",
    "data-name": "Line 78",
    x2: 3.399,
    transform: "translate(13.25)",
    fill: "none",
    stroke: "#f3a51c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_778",
    "data-name": "Group 778",
    transform: "translate(0 9.516)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_79",
    "data-name": "Line 79",
    x2: 6.447,
    fill: "none",
    stroke: "#f3a51c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_80",
    "data-name": "Line 80",
    x2: 3.404,
    transform: "translate(7.854)",
    fill: "none",
    stroke: "#f3a51c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_81",
    "data-name": "Line 81",
    x2: 3.399,
    transform: "translate(13.25)",
    fill: "none",
    stroke: "#f3a51c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_779",
    "data-name": "Group 779",
    transform: "translate(3.989 11.2)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_82",
    "data-name": "Line 82",
    x2: 4.903,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_83",
    "data-name": "Line 83",
    x2: 2.586,
    transform: "translate(5.972)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84",
    "data-name": "Line 84",
    x2: 2.586,
    transform: "translate(10.075)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_780",
    "data-name": "Group 780",
    transform: "translate(3.989 13.28)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_85",
    "data-name": "Line 85",
    x2: 4.903,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86",
    "data-name": "Line 86",
    x2: 2.586,
    transform: "translate(5.972)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87",
    "data-name": "Line 87",
    x2: 2.586,
    transform: "translate(10.075)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_783",
    "data-name": "Group 783",
    transform: "translate(0.361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M76.5,53.392l1.244-.642v.185l-1.051.528v0l1.051.528v.185L76.5,53.537Z",
    transform: "translate(-76.5 -52.337)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M81.03,53.758l.748-1.948h.185l-.752,1.948Z",
    transform: "translate(-79.038 -51.81)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M86.075,53.542l-1.245.638v-.185l1.06-.528v0l-1.06-.528V52.75l1.245.638Z",
    transform: "translate(-81.167 -52.337)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegration);
export default __webpack_public_path__ + "static/media/integration.f587074b24d1db62809aeac2811a36c2.svg";
export { ForwardRef as ReactComponent };